import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ExportDialogComponent } from '@core/components/export-dialog/export-dialog.component';
import { ExportDialogTypeEnum } from '@core/components/export-dialog/export-dialog.types';
import { SidenavService } from '@core/services/sidenav.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { merge, Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
import { DialogRecurrencesComponent } from './dialog/dialog-recurrences.component';
import { FilterRecurrencesComponent } from './filter/filter-recurrences.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { RecurrenceService } from './services/recurrence.service';
var RecurrencesComponent = /** @class */ (function () {
    function RecurrencesComponent(fuseTranslationLoaderService, fuseProgressBarService, authenticationService, recurrenceService, sidenavService, matDialog) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.authenticationService = authenticationService;
        this.recurrenceService = recurrenceService;
        this.sidenavService = sidenavService;
        this.matDialog = matDialog;
        this.filtered = false;
        this.totalCount = 0;
        this.displayedColumns = [
            'location',
            'company',
            'segment',
            'maintenanceType',
            'message',
            'createdAt',
            'edit'
        ];
        this.recurrences = [];
        this.loading = true;
        this.subscriptions = new Subject();
        this.recurrencesReload = new Subject();
        this.hasEditRecurrencePermission = this.authenticationService.hasPermission('recurrences-edit');
        this.hasCreateRecurrencePermission = this.authenticationService.hasPermission('recurrences-create');
        this.hasCreateExportPermission = this.authenticationService.hasPermission('exports-create');
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    RecurrencesComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.sort.active = 'createdAt';
                this.sort.direction = 'desc';
                merge(this.sort.sortChange, this.paginator.page, this.filterRecurrencesComponent.filterChanged.pipe(tap(function () { return _this.paginator.firstPage(); })), this.recurrencesReload).pipe(debounceTime(500), takeUntil(this.subscriptions), switchMap(function () {
                    _this.fuseProgressBarService.show();
                    _this.loading = true;
                    var options = {
                        orderBy: _this.sort.direction ? _this.sort.active + "_" + _this.sort.direction : null,
                        offset: _this.paginator.pageIndex * _this.paginator.pageSize,
                        limit: _this.paginator.pageSize
                    };
                    return _this.recurrenceService.listRecurrences({
                        where: _this.filterRecurrencesComponent.filterChanged.value,
                        options: options
                    });
                })).subscribe(function (result) {
                    _this.datatable.nativeElement.scrollTo({
                        top: 0,
                    });
                    _this.recurrences = result.items;
                    _this.filtered = result.filtered;
                    _this.totalCount = result.totalCount;
                    _this.loading = false;
                    _this.fuseProgressBarService.hide();
                });
                return [2 /*return*/];
            });
        });
    };
    RecurrencesComponent.prototype.reload = function () {
        this.recurrencesReload.next();
    };
    RecurrencesComponent.prototype.getRecurrenceById = function (recurrenceId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!recurrenceId) {
                    return [2 /*return*/, {}];
                }
                return [2 /*return*/, this.recurrenceService.getById(recurrenceId)];
            });
        });
    };
    RecurrencesComponent.prototype.openDialog = function (recurrenceId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var recurrence, dialogRecurrences, reload;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        return [4 /*yield*/, this.getRecurrenceById(recurrenceId)];
                    case 1:
                        recurrence = _a.sent();
                        dialogRecurrences = this.matDialog.open(DialogRecurrencesComponent, {
                            panelClass: 'dialog-recurrences',
                            data: {
                                recurrence: recurrence,
                                isViewMode: recurrenceId && !this.hasEditRecurrencePermission,
                                recurrencesReload: this.recurrencesReload
                            }
                        });
                        this.fuseProgressBarService.hide();
                        return [4 /*yield*/, dialogRecurrences.afterClosed().toPromise()];
                    case 2:
                        reload = _a.sent();
                        if (reload) {
                            this.reload();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RecurrencesComponent.prototype.openExportDialog = function () {
        this.matDialog.open(ExportDialogComponent, {
            panelClass: 'export-dialog',
            autoFocus: false,
            data: {
                type: ExportDialogTypeEnum.recurrences,
                limit: 10000,
                total: this.totalCount,
                where: this.filterRecurrencesComponent.filterChanged.value
            }
        });
    };
    RecurrencesComponent.prototype.clearFilters = function () {
        this.filtered = false;
        this.filterRecurrencesComponent.clearFilters();
    };
    RecurrencesComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.unsubscribe();
    };
    return RecurrencesComponent;
}());
export { RecurrencesComponent };
